import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Tiny breadcrumb trail. Pass an array of { label, to } items.
 * The LAST item is rendered as plain text (current page).
 * Pairs with the BreadcrumbList JSON-LD already in the detail page schemas.
 */
export default function Breadcrumbs({ items }) {
  if (!items || items.length === 0) return null;
  return (
    <nav data-testid="breadcrumbs" aria-label="Breadcrumb" className="mb-4">
      <ol className="flex flex-wrap items-center gap-1 text-xs text-slate-500">
        {items.map((it, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1">
              {i > 0 && <ChevronRight className="w-3 h-3 text-slate-400" aria-hidden="true" />}
              {isLast || !it.to ? (
                <span aria-current={isLast ? "page" : undefined} className="text-slate-700 font-semibold truncate max-w-[260px] sm:max-w-md" title={it.label}>
                  {it.label}
                </span>
              ) : (
                <Link to={it.to} className="hover:text-orange-600 transition-colors">
                  {it.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
